import React from 'react';
import { useDispatch } from 'react-redux';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import DeleteDonationModal from '@/components/common/contribution/DeleteContributionModal';
import MenuButton from '@/components/common/MenuButton';
import MultiActionDialogKey from '@/constants/MultiActionDialogKey';
import {
  ContributionDetailsType,
  PLEDGE_LINK_DONATION_TYPES,
} from '@/lib/configs/contributions';
import { useCurrentUser } from '@/lib/hooks/userData';
import translate from '@/lib/intl/translate';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { Dialogs, useDialogManager } from '@/modules/Dialogs';
import { useEntityDetails } from '@/modules/EntityDetails';
import userActionTypes from '@/rdx/actionTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
function DonationMenu({ donation }: any) {
  const { constituents, donationId, donationTypeEnum } = donation;
  const { constituentId, displayName } = constituents[0];
  const { isSuperAdmin, isOrgAdmin, isOrgEditor } = useCurrentUser();
  const id = 'feed-slider-menu';
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const [deleteModalActive, setDeleteModalActive] = React.useState(false);
  const dispatch = useDispatch();
  const { closeEntity } = useEntityDetails();
  const showDelete = donation.isDeletable;
  const showLinkPledge = PLEDGE_LINK_DONATION_TYPES.includes(donationTypeEnum);
  const { openDialog } = useDialogManager();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
  const openMenu = (e: any) => setMenuAnchor(e.currentTarget);
  const closeMenu = () => setMenuAnchor(null);
  const afterDelete = () => {
    closeEntity();
    setDeleteModalActive(false);
  };

  const items = [
    showLinkPledge && {
      dataTestid: 'link-donation-to-pledge-button',
      label: translate('DONATION_LINK_TO_PLEDGE'),
      onClick: () => {
        closeMenu();
        openDialog(Dialogs.LINK_TO_PLEDGE, {
          constituentId,
          displayName,
          donationId,
        });
      },
    },
    {
      label: translate('EDIT'),
      onClick: () => {
        closeMenu();
        dispatch({
          type: userActionTypes.OPEN_ACTION_DIALOG,
          dialogKey: MultiActionDialogKey.DONATION,
          data: donation,
        });
      },
    },
    showDelete && {
      label: translate('DELETE'),
      onClick: () => {
        closeMenu();
        setDeleteModalActive(true);
      },
    },
  ].filter(Boolean);
  const showControls =
    items.length && (isSuperAdmin || isOrgAdmin || isOrgEditor);

  return showControls ? (
    <>
      <MenuButton
        onClick={openMenu}
        className="ml-4 text-text-secondary"
        aria-controls={menuAnchor ? id : undefined}
        aria-haspopup="true"
        data-testid="donation-menu-button"
      />
      <Menu
        id={id}
        onClose={closeMenu}
        open={!!menuAnchor}
        anchorEl={menuAnchor}
      >
        {items.map(({ label, dataTestid, onClick }) => (
          <MenuItem key={label} onClick={onClick} data-testid={dataTestid}>
            {label}
          </MenuItem>
        ))}
      </Menu>
      <DeleteDonationModal
        donationId={donationId}
        onClose={() => setDeleteModalActive(false)}
        onSuccess={afterDelete}
        open={deleteModalActive}
      />
    </>
  ) : null;
}

DonationMenu.propTypes = {
  donation: PropTypes.shape(ContributionDetailsType).isRequired,
};

export default DonationMenu;
